import { useState, useEffect } from 'react';
import _ from 'lodash';

type Props = (initialPosition?: number, off?: boolean) => number;

const useScrollPosition: Props = (
  initialPosition = 0,
  off = false,
) => {
  const [scrollPosition, setScrollPosition] = useState(initialPosition);

  useEffect(() => {
    let ticking = false;

    const updateScrollDir = () => {
      const scrollY = window.pageYOffset;

      setScrollPosition(scrollY);
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    };

    const throttleOnScroll = _.throttle(onScroll, 100);

    /**
     * Bind the scroll handler if `off` is set to false.
     * If `off` is set to true reset the scroll direction.
     */
    // !off
    //   ? window.addEventListener('scroll', onScroll)
    //   : setScrollDir(initialDirection);
    if (off) {
      setScrollPosition(initialPosition);
    } else {
      window.addEventListener('scroll', throttleOnScroll);
    }

    return () => window.removeEventListener('scroll', throttleOnScroll);
  }, [initialPosition, off]);

  return scrollPosition;
};

export default useScrollPosition;
